module.exports = __webpack_public_path__ + "static/img/check-fn.29c644e.jpg";